import { createContext, useContext } from 'react'

export enum ListNestedLevel {
  None = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
}

export type ListState = {
  dense: boolean
  nested: ListNestedLevel
  id: string
}

export const ListContext = createContext<ListState | null>(null)

export const useList = (): ListState => useContext(ListContext) as ListState
